/**
 * Заголовок вкладки и значок приложения (CLIENT_WEB.md §8.6).
 *
 * §8.6 п. 1: суммирование `unread.conversations + unread.notifications`
 *            ЗАПРЕЩЕНО — заголовок и значок показывают только диалоги.
 * §8.6 п. 2: мигание заголовка, звук без действия пользователя и анимация
 *            favicon ЗАПРЕЩЕНЫ — префикс статичен.
 * CC §9.2 п. 4: при отсутствии Badging API он не эмулируется.
 */
import { useEffect } from 'react'

const BASE_TITLE = 'Движ'
const DEBOUNCE_MS = 500

/** Badging API поддержан не везде — типы описываем как необязательные. */
interface BadgingApi {
  setAppBadge?: (count?: number) => Promise<void>
  clearAppBadge?: () => Promise<void>
}

/** Обновляет заголовок вкладки и значок установленного приложения. */
export function useDocumentBadge(unreadConversations: number): void {
  useEffect(() => {
    const timer = setTimeout(() => {
      document.title = unreadConversations > 0 ? `(${unreadConversations}) ${BASE_TITLE}` : BASE_TITLE

      const nav = navigator as unknown as BadgingApi
      if (unreadConversations > 0) {
        void nav.setAppBadge?.(unreadConversations).catch(() => undefined)
      } else {
        void nav.clearAppBadge?.().catch(() => undefined)
      }
    }, DEBOUNCE_MS)

    return () => clearTimeout(timer)
  }, [unreadConversations])
}
